import {message} from 'antd'
import {getListSku} from '../../../services/api/apiSku'
import {EXTERNAL_ROUTES, skuDetailPath} from '../constants'

/**
 * Mở màn chi tiết của một SKU, tự lùi về danh sách khi không mở được.
 *
 * Hai service không có khoá chung: production-planning-service chỉ biết **mã SKU**
 * (`CUSTOM_ORNAMENT_V2_3D`), còn `/sku-detail/:skuID` bắt buộc **`_id` của Mongo** — `getSkuDetails`
 * chặn thẳng bằng `isMongoId(id)`. Nên phải hỏi fulfillment-service đổi mã sang `_id`.
 *
 * Tra lúc BẤM chứ không tra sẵn cả danh sách lúc mở màn: 41 SKU là 41 lượt gọi cho một thao tác mà
 * người dùng chỉ bấm một hai lần. Đổi lại thì có độ trễ, nên phải báo đang tìm — không có gì tệ hơn
 * một cái nút bấm xong im lặng vài giây.
 *
 * `sku/search` khớp gần đúng (`NAME_NIGHT_P1_0115MT` trả về cả `LNAME_NIGHT_P1_0115MT`), nên phải
 * so khớp CHÍNH XÁC lại ở đây — mở nhầm SKU khác còn tệ hơn việc về danh sách.
 */
const MESSAGE_KEY = 'goto-sku-detail'

export const gotoSkuDetail = async (history, skuId) => {
    // duration 0 = giữ tới khi tự tắt, vì không đoán được lần tra mất bao lâu.
    // `message.loading` trả về hàm đóng ĐÚNG message này; `message.destroy()` của antd 4.5.4 không
    // nhận key nên sẽ xoá sạch mọi thông báo đang hiện, kể cả của màn khác.
    const hideLoading = message.loading({content: `Đang mở chi tiết ${skuId}…`, key: MESSAGE_KEY, duration: 0})

    try {
        const {data: body} = await getListSku({sku: skuId, limit: 20, page: 1})
        const items = ((body || {}).data || {}).items || []
        const found = items.find((item) => item && item.sku === skuId && item._id)

        if (found) {
            hideLoading()
            history.push(skuDetailPath(found._id))

            return true
        }

        message.warning({
            content: `Không tra được mã ${skuId} trong danh mục SKU — mở màn Quản lý SKU để tìm thủ công`,
            key: MESSAGE_KEY,
            duration: 4,
        })
    } catch (e) {
        message.warning({
            content: 'Không tra được chi tiết SKU — mở màn Quản lý SKU',
            key: MESSAGE_KEY,
            duration: 4,
        })
    }

    history.push(EXTERNAL_ROUTES.SKU_MANAGER)

    return false
}
